export function consoleLogFunction(line, message) {
    if (process.env.REACT_APP_VIEW_CONSOLE === "true") return console.log(line, message);
  }
  